<template lang="pug" src="./html/SmartCityHelsinki-Body.pug"></template>

<script>
  import ArticleItemBase from './ArticleItemBase'

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setupVideo('121141402', 'https://player.youku.com/embed/XNDAxNDU2NTI0MA==')
      this.setupVideo('124794845', 'https://player.youku.com/embed/XNDAxNDU2NTM5Mg==', this.$refs.video_player2)
    }
  }
</script>

<style scoped>
    h2, a, .img span.caption {
        color: #05377E;
    }
    .video, .video .loading {
        height: 56.25vw
    }
</style>
